import { useCallback, useReducer } from 'react';
import { S3_URL } from '../libs/common';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

//초기상태
const initialState = {
  ui: {
    mainBannerIndex: 0,
    isAutoPlay: true,
  },
  data: {
    currentSlideData: null,
  },
};

const homeBannerReducer = (state, action) => {
  switch (action.type) {
    case 'SET_UI':
      return {
        ...state,
        ui: { ...state.ul, ...action.payload },
      };
    case 'SET_DATA':
      return {
        ...state,
        data: { ...state.data, ...action.payload },
      };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};

class HomeBannerService {
  validateBannerUrl = (url) => {
    return /^(http|https):\/\//.test(url);
  };

  getBannerImageUrl = (bannerImg) => {
    return `${S3_URL(bannerImg)}`;
  };
}

export const useHomeBanner = () => {
  const [state, dispatch] = useReducer(homeBannerReducer, initialState);
  const history = useHistory();
  const homeBannerService = new HomeBannerService();

  const actions = {
    setUI: useCallback((payload) => {
      dispatch({ type: 'SET_UI', payload });
    }, []),

    setData: useCallback((payload) => {
      dispatch({ type: 'SET_DATA', payload });
    }, []),

    /** 슬라이드 변경 시 처리 */
    handleMainSlideChange: useCallback(
      (e) => {
        const { item: index } = e;
        dispatch({
          type: 'SET_UI',
          payload: { mainBannerIndex: index },
        });
      },
      [state],
    ),

    goBannerUrl: useCallback(
      (url, eventId) => {
        if (!url && !eventId) return;

        if (eventId) {
          history.push(`/events/view/${eventId}`);
        } else if (homeBannerService.validateBannerUrl(url)) {
          window.open(url, '_blank');
        } else {
          history.push(url);
        }
      },
      [history],
    ),
  };

  return {
    state,
    actions,
  };
};
